var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/results.template.html');

var OptimalSolutionView = require('views/results/optimal_solution.view.ts');
var EconomicMetricsView = require('views/results/economic_metrics.view.ts');
var TechnicalMetricsView = require('views/results/technical_metrics.view.ts');
var ThermalDemandView = require('views/results/thermal_demand.view.ts');
var ElectricalDemandView = require('views/results/electrical_demand.view.ts');

var TheView = GenericView.extend({
    el: '#results',
    tagName: '',
	template: Handlebars.compile(Template),
	frontEndData: null,
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
      "click .ui-tabview-nav.results .nav-item": "changeTab",
      "click #resultsB": "showResults",
      "click #staticDataB": "loadStaticData"
    },
    changeTab: function(event)
    {
      event.stopPropagation();
      this.$el.find(".ui-tabview-nav.results").find("li.active").removeClass("active");
      $(event.currentTarget).addClass("active");

      this.$el.find(".ui-tabview-panels.results > .show").removeClass("show");
      var id = $(event.currentTarget).data("id");
      $("#" + id).addClass("show");

    },
    renderTabsContent: function(response, frontEndData) {
        var optimal_solution_view = new OptimalSolutionView({"data": response.data});
        var economic_metrics_view = new EconomicMetricsView({"data": response.data});
        var technical_metrics_view = new TechnicalMetricsView({"data": response.data});
        var thermal_demand_view = new ThermalDemandView({"frontEndData": frontEndData, "data": response.data});
        var electrical_demand_view = new ElectricalDemandView({"frontEndData": frontEndData, "data": response.data});
    },
    showResults: function() {
        var self = this;

        //show loader and disabled buttons
        $("#response").text("");
        $(".lds-dual-ring").show();
        $("#resultsB").prop('disabled', true);
        $("#staticDataB").prop('disabled', true);

        var has_error = this.validateAll();

        if (has_error == true) {
            $("#resultsB").notify("Some of your inputs are invalid. Please check the corresponding fields with an error message underneath them.", { className: "error", position: "bottom center" });
            $(".lds-dual-ring").hide();
            $("#resultsB").prop('disabled', false);
            $("#staticDataB").prop('disabled', false);
        } else {
            this.frontEndData = this.createJson();
            $.ajax({
                url: "api/calculations",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(self.frontEndData),
            }).done(function(response) {
                //hide loader and buttons
                $(".lds-dual-ring").hide();
                $("#resultsB").prop('disabled', false);
                $("#staticDataB").prop('disabled', false);
                $(".resultsB-container").hide();
                $(".results-container").show();

                self.renderTabsContent(response, self.frontEndData);
            }).fail(function(resp, xhr, errorMessage) {
                //hide loader and allow buttons
                $(".lds-dual-ring").hide();
                $("#resultsB").prop('disabled', false);
                $("#staticDataB").prop('disabled', false);

                if(resp.status == 502) {
                    $("#response").text("Server is down or under maintenance");
                }
                else if(resp.status == 500) {
                    $("#response").html("There was an error with the calculation. Please check the data that you have inserted.<br/>Code: "+ resp.status);
                }
                else {
                    $("#response").html("Server Error<br/>Code: "+ resp.status);
                }
                console.error("resp: ", resp);
                console.error("xhr: ", xhr);
                console.error("status: ", errorMessage);
            });
        }

    },
    loadStaticData: function() {
       var static_data = window.inputData;
/*
       var static_data = {
         "data": {
             "generalOutputs": {
               "maxNPV": 5592.44,
               "optimal_PVsize": 2,
               "optimal_BATsize": 3.3333333,
               "spp": 7.5594893,
               "irr": 13.449483
             },
             "parametricSCR": [
               24.797112,
               48.684414,
               51.406826,
               52.50442
             ],
             "parametricSSR": [
               43.455807,
               91.714005,
               96.11013,
               97.81475
             ],
             "thermalDemand": {
               "heating": [
                 963.905,
                 910.56415,
                 734.0108,
                 376.0273,
                 61.276382,
                 8.946556,
                 0,
                 0,
                 11.9371395,
                 274.43454,
                 467.79004,
                 854.60297
               ],
               "cooling": [
                 0,
                 0,
                 0,
                 0,
                 0,
                 8.5747,
                 105.91226,
                 133.62817,
                 29.50838,
                 0,
                 0,
                 0
               ]
             },
             "electricalDemand": [
               146.00592,
               131.83485,
               145.89815,
               141.28183,
               146.0059,
               140.99509,
               145.7025,
               145.6994,
               141.22795,
               146.00592,
               141.22801,
               145.95187
             ],
             "year": [
               0,
               1,
               2,
               3,
               4,
               5,
               6,
               7,
               8,
               9,
               10,
               11,
               12,
               13,
               14,
               15,
               16,
               17,
               18,
               19,
               20
             ],
             "batSizes": [
               0,
               3.3333333,
               6.6666665,
               10
             ],
             "irr": [
               -0.0043888446,
               13.449483,
               8.22522,
               4.819592
             ],
             "lcoe": [
               [
                 0.04861696,
                 0.08176489,
                 0.11491281,
                 0.14806074
               ]
             ],
             "lcou": [
               [
                 0.18324092,
                 0.08460522,
                 0.11868588,
                 0.15280887
               ]
             ],
             "scr": [
               [
                 24.797112,
                 48.684414,
                 51.406826,
                 52.50442
               ]
             ],
             "ssr": [
               [
                 43.455807,
                 91.714005,
                 96.11013,
                 97.81475
               ]
             ],
             "npv_pv": [
               -418.66995,
               5592.44,
               3825.898,
               2048.4448
             ],
             "pvsizes": [
               2
             ],
             "npv_bat": [
               5592.44
             ],
             "noCF": [
               {
                 "year": 0,
                 "capexPv": -2200,
                 "capexBess": -1500,
                 "subsidies": 0,
                 "opexPv": 0,
                 "opexBess": 0,
                 "netEnergyBenefits": 0,
                 "discountedCashFlow": -3700
               },
               {
                 "year": 1,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -22.33,
                 "opexBess": -15.224999,
                 "netEnergyBenefits": 299.98752,
                 "discountedCashFlow": 262.43253
               },
               {
                 "year": 2,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -22.664948,
                 "opexBess": -15.453374,
                 "netEnergyBenefits": 609.6929,
                 "discountedCashFlow": 571.5745
               },
               {
                 "year": 3,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -23.004925,
                 "opexBess": -15.685176,
                 "netEnergyBenefits": 612.1513,
                 "discountedCashFlow": 573.4612
               },
               {
                 "year": 4,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -23.349997,
                 "opexBess": -15.920452,
                 "netEnergyBenefits": 614.6267,
                 "discountedCashFlow": 575.35626
               },
               {
                 "year": 5,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -23.700247,
                 "opexBess": -16.15926,
                 "netEnergyBenefits": 617.11975,
                 "discountedCashFlow": 577.26025
               },
               {
                 "year": 6,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -24.05575,
                 "opexBess": -16.401648,
                 "netEnergyBenefits": 619.6292,
                 "discountedCashFlow": 579.1718
               },
               {
                 "year": 7,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -24.416586,
                 "opexBess": -16.647673,
                 "netEnergyBenefits": 622.1555,
                 "discountedCashFlow": 581.09125
               },
               {
                 "year": 8,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -24.782835,
                 "opexBess": -16.897388,
                 "netEnergyBenefits": 624.69904,
                 "discountedCashFlow": 583.0188
               },
               {
                 "year": 9,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -25.154575,
                 "opexBess": -17.150846,
                 "netEnergyBenefits": 627.25964,
                 "discountedCashFlow": 584.9542
               },
               {
                 "year": 10,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -25.531895,
                 "opexBess": -17.40811,
                 "netEnergyBenefits": 629.837,
                 "discountedCashFlow": 586.897
               },
               {
                 "year": 11,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -25.914871,
                 "opexBess": -17.669231,
                 "netEnergyBenefits": 632.432,
                 "discountedCashFlow": 588.8479
               },
               {
                 "year": 12,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -26.303595,
                 "opexBess": -17.934269,
                 "netEnergyBenefits": 635.0441,
                 "discountedCashFlow": 590.8063
               },
               {
                 "year": 13,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -26.698149,
                 "opexBess": -18.203283,
                 "netEnergyBenefits": 637.67365,
                 "discountedCashFlow": 592.7722
               },
               {
                 "year": 14,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -27.098621,
                 "opexBess": -18.476332,
                 "netEnergyBenefits": 640.32007,
                 "discountedCashFlow": 594.7451
               },
               {
                 "year": 15,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -27.505098,
                 "opexBess": -18.753475,
                 "netEnergyBenefits": 642.98364,
                 "discountedCashFlow": 596.7251
               },
               {
                 "year": 16,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -27.917675,
                 "opexBess": -19.034779,
                 "netEnergyBenefits": 645.6652,
                 "discountedCashFlow": 598.71277
               },
               {
                 "year": 17,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -28.336441,
                 "opexBess": -19.320301,
                 "netEnergyBenefits": 648.3636,
                 "discountedCashFlow": 600.70685
               },
               {
                 "year": 18,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -28.761486,
                 "opexBess": -19.610104,
                 "netEnergyBenefits": 651.0791,
                 "discountedCashFlow": 602.7075
               },
               {
                 "year": 19,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -29.19291,
                 "opexBess": -19.904257,
                 "netEnergyBenefits": 653.81323,
                 "discountedCashFlow": 604.71606
               },
               {
                 "year": 20,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -29.6308,
                 "opexBess": -20.202818,
                 "netEnergyBenefits": 656.56366,
                 "discountedCashFlow": 606.73004
               }
             ],
             "diCF": [
               {
                 "year": 0,
                 "capexPv": -2200,
                 "capexBess": -1500,
                 "subsidies": 0,
                 "opexPv": 0,
                 "opexBess": 0,
                 "netEnergyBenefits": 0,
                 "discountedCashFlow": -3700
               },
               {
                 "year": 1,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.892157,
                 "opexBess": -14.926471,
                 "netEnergyBenefits": 294.1054,
                 "discountedCashFlow": 257.2868
               },
               {
                 "year": 2,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.784842,
                 "opexBess": -14.853302,
                 "netEnergyBenefits": 586.0178,
                 "discountedCashFlow": 549.37964
               },
               {
                 "year": 3,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.678057,
                 "opexBess": -14.780493,
                 "netEnergyBenefits": 576.84393,
                 "discountedCashFlow": 540.3853
               },
               {
                 "year": 4,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.57179,
                 "opexBess": -14.708038,
                 "netEnergyBenefits": 567.8201,
                 "discountedCashFlow": 531.54034
               },
               {
                 "year": 5,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.466045,
                 "opexBess": -14.6359415,
                 "netEnergyBenefits": 558.94446,
                 "discountedCashFlow": 522.84247
               },
               {
                 "year": 6,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.36082,
                 "opexBess": -14.564196,
                 "netEnergyBenefits": 550.2131,
                 "discountedCashFlow": 514.288
               },
               {
                 "year": 7,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.25611,
                 "opexBess": -14.492802,
                 "netEnergyBenefits": 541.62384,
                 "discountedCashFlow": 505.87494
               },
               {
                 "year": 8,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.151915,
                 "opexBess": -14.421761,
                 "netEnergyBenefits": 533.1747,
                 "discountedCashFlow": 497.60098
               },
               {
                 "year": 9,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -21.048227,
                 "opexBess": -14.351064,
                 "netEnergyBenefits": 524.8629,
                 "discountedCashFlow": 489.46362
               },
               {
                 "year": 10,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.945051,
                 "opexBess": -14.280717,
                 "netEnergyBenefits": 516.6858,
                 "discountedCashFlow": 481.46005
               },
               {
                 "year": 11,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.842377,
                 "opexBess": -14.210712,
                 "netEnergyBenefits": 508.64175,
                 "discountedCashFlow": 473.58868
               },
               {
                 "year": 12,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.74021,
                 "opexBess": -14.141051,
                 "netEnergyBenefits": 500.72806,
                 "discountedCashFlow": 465.8468
               },
               {
                 "year": 13,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.638542,
                 "opexBess": -14.071733,
                 "netEnergyBenefits": 492.9426,
                 "discountedCashFlow": 458.23233
               },
               {
                 "year": 14,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.537374,
                 "opexBess": -14.002754,
                 "netEnergyBenefits": 485.2827,
                 "discountedCashFlow": 450.74258
               },
               {
                 "year": 15,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.436699,
                 "opexBess": -13.934112,
                 "netEnergyBenefits": 477.74643,
                 "discountedCashFlow": 443.37564
               },
               {
                 "year": 16,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.33652,
                 "opexBess": -13.8658085,
                 "netEnergyBenefits": 470.33224,
                 "discountedCashFlow": 436.12994
               },
               {
                 "year": 17,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.236832,
                 "opexBess": -13.79784,
                 "netEnergyBenefits": 463.03714,
                 "discountedCashFlow": 429.00247
               },
               {
                 "year": 18,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.13763,
                 "opexBess": -13.730203,
                 "netEnergyBenefits": 455.85928,
                 "discountedCashFlow": 421.99146
               },
               {
                 "year": 19,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -20.038918,
                 "opexBess": -13.662898,
                 "netEnergyBenefits": 448.79767,
                 "discountedCashFlow": 415.09583
               },
               {
                 "year": 20,
                 "capexPv": 0,
                 "capexBess": 0,
                 "subsidies": 0,
                 "opexPv": -19.940685,
                 "opexBess": -13.5959215,
                 "netEnergyBenefits": 441.84866,
                 "discountedCashFlow": 408.31207
               }
             ]
           },
           "status": "OK",
           "code": 200,
           "error": null,
           "extras": {
             "totalTime": "2 minute(s), 58 second(s)",
             "individualTimes": {
               "MainGeneralThermalLoad": "0 minute(s), 52 second(s)",
               "PVBessSimp": "1 minute(s), 4 second(s)",
               "AppPowCalc": "1 minute(s), 1 second(s)"
             }
           }
       };
*/
       this.renderTabsContent(static_data);
       $(".resultsB-container").hide();
       $(".results-container").show();

    },
    validateAll: function() {
        var has_error = false;
        var fields = $('body').find(".to-validation input");
        has_error = GenericView.prototype.validateFields(fields);

        return has_error;
    },
    createJson: function() {
        var views = GenericView.prototype.views;
        var data = {
            "general": views["general"].getAllData(),
            "load": {
                "thermal": views["thermal"].getAllData(),
                "electrical": views["electrical"].getAllData()
            },
            "components": {
                "appliances": views["appliances"].getAllData(),
                "pv": views["pv"].getAllData(),
                "bess": views["bess"].getAllData()
            },
            "electricity": views["electricity"].getAllData(),
            "energy": views["energy"].getAllData(),
            "project": views["project"].getAllData()
        };

        return data;
    }
});

module.exports= TheView;